import Service from "./service";
import axios from "axios";
export default class extends Service {
  constructor() {
    super(...arguments);
    this.setEndPoint("stock-supplier");
  }

  getByStockId(stockId) {
    return axios.get(`${this.url}?getByStockId&stockId=${stockId}`);
  }

  getBySupplierId(supplierId) {
    return axios.get(`${this.url}?getBySupplierId&supplierId=${supplierId}`);
  }
}
